/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_Event_RelatedInputs */

const en_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Related`)
};

const fr_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lie a un evenement`)
};

const de_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisbezogen`)
};

const it_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento correlato`)
};

const ru_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие, связанное с`)
};

const es_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado con el evento`)
};

const zh_cn2_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件相关`)
};

const ja_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント関連`)
};

const hi_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम से संबंधित`)
};

const pt_pt2_manual_qc_export_event_related = /** @type {(inputs: Manual_Qc_Export_Event_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento relacionado`)
};

/**
* | output |
* | --- |
* | "Event Related" |
*
* @param {Manual_Qc_Export_Event_RelatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_event_related = /** @type {((inputs?: Manual_Qc_Export_Event_RelatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_Event_RelatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_event_related(inputs)
	if (locale === "de") return de_manual_qc_export_event_related(inputs)
	if (locale === "it") return it_manual_qc_export_event_related(inputs)
	if (locale === "ru") return ru_manual_qc_export_event_related(inputs)
	if (locale === "es") return es_manual_qc_export_event_related(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_event_related(inputs)
	if (locale === "ja") return ja_manual_qc_export_event_related(inputs)
	if (locale === "hi") return hi_manual_qc_export_event_related(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_event_related(inputs)
	return en_manual_qc_export_event_related(inputs)
});